module.exports = __webpack_public_path__ + "static/media/WIPRO.be43d380.txt";